<template>
  <div class="recharge-page">
    <div class="recharge-head">
      <img @click="fanhui" src="../../assets/images/licai/fanhui.png" />
      <p>充值</p>
    </div>

    <div class="recharge-body">
      <section class="collection-card">
        <div class="collection-title">
          <div>
            <strong>USD 充值服务</strong>
            <span>{{ rechargeConfig.network || "TRC20" }}</span>
          </div>
          <small>安全 · 专业 · 高效</small>
        </div>
        <div class="collection-brand">
          <img src="../../assets/images/asmpt_logo.svg" alt="ASMPT" />
          <p>GLOBAL SEMICONDUCTOR TECHNOLOGY</p>
        </div>
        <div class="payment-panel">
          <div class="payment-panel-title">
            <div>
              <strong>官方收款信息</strong>
              <span>请核对 {{ rechargeConfig.network || "TRC20" }} 网络</span>
            </div>
            <i>SECURE</i>
          </div>
          <div v-if="rechargeConfig.qrcode" class="qrcode-box">
            <img :src="rechargeConfig.qrcode" alt="USD收款二维码" />
            <small>扫描二维码完成转账</small>
          </div>
          <div v-else class="qrcode-empty">
            收款二维码暂未配置
          </div>
          <div class="address-box">
            <span>USD 收款地址</span>
            <code>{{ rechargeConfig.address || "后台暂未配置收款地址" }}</code>
            <button
              type="button"
              :disabled="!rechargeConfig.address"
              @click="copyAddress"
            >
              复制收款地址
            </button>
          </div>
          <p class="network-tip">
            转账前请确认网络与收款地址完全一致，避免资产无法到账。
          </p>
        </div>
        <p v-if="rechargeConfig.remark" class="collection-remark">
          {{ rechargeConfig.remark }}
        </p>
      </section>

      <section class="amount-card">
        <label>金额</label>
        <input
          ref="amountInput"
          type="number"
          inputmode="decimal"
          placeholder="请输入充值金额"
          v-model="money"
        />
        <span>USD</span>
        <button v-if="money" type="button" @click="money = ''">×</button>
      </section>

      <section class="proof-card">
        <div class="proof-title">
          <label>上传转账凭证</label>
          <span>转账成功后的截图记录</span>
        </div>
        <label class="proof-upload" for="recharge-proof-input">
          <img v-if="proofPreview" :src="proofPreview" alt="转账凭证" />
          <div v-else class="proof-placeholder">
            <strong>{{ uploadingProof ? "上传中..." : "点击上传截图" }}</strong>
            <p>支持 JPG、PNG、WEBP，最大 10MB</p>
          </div>
          <div v-if="proofPreview && uploadingProof" class="proof-mask">上传中...</div>
        </label>
        <input
          id="recharge-proof-input"
          class="proof-file-input"
          type="file"
          accept="image/jpeg,image/png,image/webp"
          :disabled="uploadingProof"
          @change="onProofSelected"
        />
      </section>

      <button
        class="submit-btn"
        :disabled="submitting || !rechargeConfig.address"
        @click="registerReset"
      >
        {{ submitting ? "提交中" : "确定充值" }}
      </button>
    </div>

    <div style="height: 82px;"></div>
  </div>
</template>

<script>
import request from "@utils/request";
import { getMyUserInfo } from "@api/user";
import lrz from "lrz";

export default {
  name: "CzContent",
  data() {
    return {
      money: "",
      proof: "",
      proofPreview: "",
      proofObjectUrl: "",
      uploadingProof: false,
      submitting: false,
      rechargeConfig: {
        address: "",
        qrcode: "",
        remark: "",
        network: "TRC20"
      }
    };
  },
  beforeDestroy() {
    this.revokeProofObjectUrl();
  },
  mounted() {
    if (this.$refs.amountInput) {
      this.$refs.amountInput.focus();
    }
    getMyUserInfo().then(res => {
      const userInfo = res.data.data;
      if (userInfo.is_auth != 1) {
        this.$router.push({ name: "memmber_business" });
      }
    });
    this.loadRechargeConfig();
  },
  methods: {
    loadRechargeConfig() {
      request
        .post("/pay/us/cache", {}, { login: true })
        .then(res => {
          const data = (res && res.data && res.data.data) || {};
          this.rechargeConfig = Object.assign(
            {},
            this.rechargeConfig,
            data.recharge || {
              address: data.usdt_address || data.usd_address || "",
              qrcode: data.usdt_qrcode || data.usd_qrcode || "",
              remark: data.usdt_remark || data.usd_remark || "",
              network: data.usdt_network || data.usd_network || "TRC20"
            }
          );
        })
        .catch(err => {
          const msg =
            err && err.response && err.response.data && err.response.data.msg
              ? err.response.data.msg
              : "充值配置加载失败，请刷新页面重试";
          this.$dialog.error(msg);
        });
    },
    copyAddress() {
      const address = this.rechargeConfig.address;
      if (!address) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(address).then(() => {
          this.$dialog.success("收款地址已复制");
        });
        return;
      }
      const input = document.createElement("textarea");
      input.value = address;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$dialog.success("收款地址已复制");
    },
    async onProofSelected(event) {
      const input = event && event.target;
      const rawFile = input && input.files && input.files[0];
      if (!rawFile) {
        return;
      }
      if (rawFile.size > 10 * 1024 * 1024) {
        this.onProofOversize();
        input.value = "";
        return;
      }
      await this.afterReadProof(rawFile);
      // Allow selecting the same screenshot again after a failed upload.
      input.value = "";
    },
    revokeProofObjectUrl() {
      if (
        this.proofObjectUrl &&
        window.URL &&
        window.URL.revokeObjectURL
      ) {
        window.URL.revokeObjectURL(this.proofObjectUrl);
      }
      this.proofObjectUrl = "";
    },
    async afterReadProof(rawFile) {
      if (this.uploadingProof) {
        return;
      }
      this.uploadingProof = true;
      if (window.URL && window.URL.createObjectURL) {
        this.revokeProofObjectUrl();
        this.proofObjectUrl = window.URL.createObjectURL(rawFile);
        this.proofPreview = this.proofObjectUrl;
      }
      this.proof = "";

      try {
        // Normalise large mobile photos to a regular JPEG. This keeps the
        // multipart request below both the page limit and typical PHP/nginx
        // upload limits, and avoids extension/MIME mismatches from WebViews.
        let uploadFile = rawFile;
        let uploadName = rawFile.name || "recharge-proof.jpg";
        if (rawFile.size > 2 * 1024 * 1024) {
          try {
            const compressed = await lrz(rawFile, {
              width: 1920,
              height: 1920,
              quality: 0.85
            });
            if (compressed && compressed.file) {
              uploadFile = compressed.file;
              uploadName = "recharge-proof.jpg";
            }
          } catch (compressionError) {
            // Some embedded WebViews cannot draw every image through canvas.
            // The original file is still valid and remains below the 10MB
            // uploader limit, so let the server validate it normally.
            console.warn("转账凭证压缩失败，改用原图上传", compressionError);
          }
        }

        const formData = new FormData();
        formData.append("file", uploadFile, uploadName);
        const res = await request.post("/pay/recharge/upload", formData, {
          login: true,
          timeout: 60000
        });
        const data = res && res.data && res.data.data ? res.data.data : {};
        if (!data.url) {
          throw new Error("上传接口未返回图片地址");
        }
        this.proof = data.url;
        this.proofPreview = data.full_url || data.url;
        this.revokeProofObjectUrl();
      } catch (err) {
        const msg =
          err && err.response && err.response.data && err.response.data.msg
            ? err.response.data.msg
            : err && err.message
            ? err.message
            : "上传失败,请重试";
        this.$dialog.error(msg);
      } finally {
        this.uploadingProof = false;
      }
    },
    onProofOversize() {
      this.$dialog.error("图片大小不能超过10MB");
    },
    fanhui() {
      this.$router.push({ path: "/" });
    },
    registerReset() {
      if (!this.rechargeConfig.address) {
        this.$dialog.error("充值收款地址暂未配置，请联系客服");
        return;
      }
      const amount = Number(this.money);
      if (!amount || amount <= 0) {
        this.$dialog.message("请输入充值金额");
        return;
      }
      if (this.uploadingProof) {
        this.$dialog.message("转账凭证正在上传，请稍后");
        return;
      }
      if (!this.proof) {
        this.$dialog.message("请上传转账凭证截图");
        return;
      }
      this.submitting = true;
      request
        .post(
          "/pay/us/recharge",
          { money: this.money, proof: this.proof, remark: this.proof },
          { login: true }
        )
        .then(res => {
          this.$dialog.success(res.data.msg);
          this.$router.push({ path: "/deposit_record" });
        })
        .catch(err => {
          this.$dialog.error(err.response.data.msg);
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>

<style scoped lang="less">
.recharge-page {
  min-height: 100%;
  color: #121826;
  background: #f4f7fb;
}
.recharge-head {
  position: sticky;
  top: 0;
  z-index: 5;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 1px 0 rgba(12, 22, 46, 0.05);
}
.recharge-head img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 14px;
}
.recharge-head p {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
}
.recharge-body {
  padding: 14px 12px 0;
}

.collection-card {
  position: relative;
  margin-bottom: 14px;
  padding: 18px;
  overflow: hidden;
  background:
    linear-gradient(90deg,rgba(4,29,65,.97),rgba(7,57,105,.73)),
    url("../../assets/images/asm-premium/advanced-packaging-fab.webp") 68% center / cover no-repeat;
  border-radius: 16px;
  box-shadow: 0 12px 28px rgba(18, 74, 132, 0.18);
}
.collection-card::after { position: absolute; right: -42px; bottom: -58px; width: 190px; height: 190px; content: ""; border: 1px solid rgba(128,201,255,.18); border-radius: 50%; box-shadow: 0 0 0 25px rgba(128,201,255,.045),0 0 0 51px rgba(128,201,255,.025); pointer-events: none; }
.collection-card > * { position: relative; z-index: 1; }
.collection-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  color: #fff;
}
.collection-title strong {
  display: block;
  font-size: 17px;
}
.collection-title span {
  display: inline-block;
  margin-top: 6px;
  padding: 2px 8px;
  color: #183b67;
  font-size: 11px;
  background: #d9edff;
  border-radius: 9px;
}
.collection-title small {
  max-width: 150px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 11px;
  line-height: 1.5;
  text-align: right;
}
.collection-brand {
  display: flex;
  min-height: 92px;
  flex-direction: column;
  justify-content: flex-end;
  padding: 22px 0 16px;
}
.collection-brand img {
  width: 178px;
  height: auto;
  filter: brightness(0) invert(1);
  opacity: .92;
}
.collection-brand p {
  margin: 10px 0 0;
  color: rgba(220,239,255,.72);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1.4px;
}
.payment-panel {
  padding: 14px;
  background: rgba(246, 251, 255, .96);
  border: 1px solid rgba(255,255,255,.72);
  border-radius: 14px;
  box-shadow: 0 14px 32px rgba(2,24,54,.2);
  backdrop-filter: blur(8px);
}
.payment-panel-title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 13px;
}
.payment-panel-title strong,
.payment-panel-title span {
  display: block;
}
.payment-panel-title strong {
  color: #142b49;
  font-size: 14px;
}
.payment-panel-title span {
  margin-top: 4px;
  color: #748399;
  font-size: 10px;
}
.payment-panel-title i {
  padding: 4px 7px;
  color: #1b6da8;
  font-size: 8px;
  font-style: normal;
  font-weight: 800;
  letter-spacing: .8px;
  background: #e1f2ff;
  border-radius: 8px;
}
.payment-panel .qrcode-box {
  width: 148px;
  height: auto;
  margin: 0 auto 13px;
  padding: 9px 9px 7px;
  text-align: center;
  background: #fff;
  border: 1px solid #dce8f3;
  border-radius: 13px;
  box-shadow: 0 9px 22px rgba(28,72,113,.1);
}
.payment-panel .qrcode-box img {
  display: block;
  width: 128px;
  height: 128px;
  object-fit: contain;
}
.payment-panel .qrcode-box small {
  display: block;
  margin-top: 7px;
  color: #758399;
  font-size: 9px;
}
.qrcode-empty {
  margin-bottom: 13px;
  padding: 28px 12px;
  color: #8592a3;
  font-size: 11px;
  text-align: center;
  background: #eef4f9;
  border: 1px dashed #cbd9e6;
  border-radius: 12px;
}
.collection-card .address-box {
  display: block;
  padding: 12px;
  background: #eaf2f9;
  border: 1px solid #d4e2ee;
  border-radius: 11px;
}
.collection-card .address-box span {
  display: block;
  margin-bottom: 7px;
  color: #58708b;
  font-size: 10px;
  font-weight: 800;
}
.collection-card .address-box code {
  display: block;
  color: #142842;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.55;
  overflow-wrap: anywhere;
  word-break: break-all;
}
.collection-card .address-box button {
  width: 100%;
  height: 36px;
  margin-top: 10px;
  padding: 0;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  background: linear-gradient(90deg,#15558e,#1681c5);
  border: 0;
  border-radius: 18px;
  box-shadow: 0 8px 17px rgba(19,91,147,.18);
}
.collection-card .address-box button:disabled {
  color: #8a96a4;
  background: #d4dde6;
  box-shadow: none;
}
.network-tip {
  margin: 10px 2px 0;
  color: #718095;
  font-size: 9px;
  line-height: 1.55;
}
.qrcode-box {
  width: 170px;
  height: 170px;
  margin: 18px auto 14px;
  padding: 7px;
  background: #fff;
  border-radius: 12px;
}
.qrcode-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.address-box {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px 11px;
  background: rgba(255, 255, 255, 0.11);
  border-radius: 9px;
}
.address-box code {
  flex: 1;
  overflow-wrap: anywhere;
  color: #fff;
  font-size: 12px;
  line-height: 1.55;
}
.address-box button {
  flex: 0 0 auto;
  padding: 7px 12px;
  color: #165fa7;
  background: #fff;
  border: 0;
  border-radius: 14px;
}
.collection-remark {
  margin: 11px 2px 0;
  color: #d8eaff;
  font-size: 12px;
  line-height: 1.6;
}
.method-card,
.amount-card,
.info-card,
.proof-card {
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(22, 65, 118, 0.06);
}
.method-card {
  min-height: 76px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.method-left {
  display: flex;
  align-items: center;
  min-width: 0;
}
.method-icon {
  width: 28px;
  height: 28px;
  line-height: 28px;
  margin-right: 12px;
  border-radius: 50%;
  text-align: center;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(135deg, #123b68, #2587ce);
  box-shadow: 0 8px 18px rgba(28, 124, 255, 0.22);
}
.method-left p {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 800;
}
.method-left span {
  font-size: 12px;
  color: #7a8495;
}
.check-dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #1677ff;
  position: relative;
}
.check-dot::after {
  content: "";
  width: 8px;
  height: 4px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  position: absolute;
  left: 5px;
  top: 6px;
  transform: rotate(-45deg);
}
.amount-card {
  height: 84px;
  margin-top: 10px;
  padding: 0 14px;
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr) auto 22px;
  align-items: center;
  column-gap: 8px;
}
.amount-card label,
.proof-card label {
  font-size: 16px;
  font-weight: 900;
}
.amount-card input {
  min-width: 0;
  height: 44px;
  border: 0;
  outline: none;
  font-size: 18px;
  color: #121826;
}
.amount-card input::placeholder {
  color: #9aa5b5;
}
.amount-card span {
  font-size: 14px;
  font-weight: 800;
  color: #4b5565;
}
.amount-card button {
  width: 20px;
  height: 20px;
  border: 0;
  border-radius: 50%;
  color: #ffffff;
  background: #a7afba;
  line-height: 18px;
}
.info-card {
  margin-top: 10px;
  padding: 16px;
}
.card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-title strong {
  font-size: 16px;
}
.card-title span {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 800;
  color: #0d7f56;
  background: #e7fff4;
}
.qr-wrap {
  width: 170px;
  height: 170px;
  margin: 16px auto 14px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7fafc;
  border: 1px solid #e6edf5;
}
.qr-wrap img {
  max-width: 150px;
  max-height: 150px;
  display: block;
}
.qr-empty {
  font-size: 13px;
  color: #8a94a6;
}
.address-box {
  padding: 12px;
  border-radius: 8px;
  background: #f7f9fc;
  border: 1px solid #e8edf4;
}
.address-box span {
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 800;
  color: #697586;
}
.address-box p {
  margin: 0;
  word-break: break-all;
  font-size: 13px;
  line-height: 20px;
  color: #111827;
}
.address-box button {
  width: 100%;
  height: 38px;
  margin-top: 12px;
  border: 0;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 800;
  color: #ffffff;
  background: #1677ff;
}
.address-box button:disabled {
  background: #b7c0ce;
}
.notice {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  color: #4d6680;
  background: #edf5fb;
  font-size: 12px;
  line-height: 18px;
}
.proof-card {
  margin-top: 10px;
  padding: 14px;
}
.proof-title {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}
.proof-title span {
  font-size: 12px;
  color: #7a8495;
}
.proof-upload {
  position: relative;
  display: block;
  height: 178px;
  margin-top: 12px;
  border: 1px dashed #cbd7e6;
  border-radius: 8px;
  overflow: hidden;
  background: #f7fafc;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(22, 119, 255, 0.08);
}
.proof-upload img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.proof-placeholder {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #667085;
}
.proof-placeholder strong {
  font-size: 15px;
  color: #1677ff;
}
.proof-placeholder p {
  margin: 8px 0 0;
  font-size: 12px;
}
.proof-mask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 36px;
  line-height: 36px;
  color: #fff;
  text-align: center;
  background: rgba(0, 0, 0, 0.48);
}
.proof-file-input {
  position: fixed;
  left: -10000px;
  bottom: auto;
  width: 1px;
  height: 1px;
  margin: 0;
  padding: 0;
  opacity: 0;
  -webkit-appearance: auto !important;
  appearance: auto !important;
}
.submit-btn {
  width: 100%;
  height: 50px;
  margin-top: 18px;
  border: 0;
  border-radius: 25px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 900;
  background: linear-gradient(135deg, #1677ff 0%, #006dff 100%);
  box-shadow: 0 12px 24px rgba(22, 119, 255, 0.2);
}
.submit-btn:disabled {
  opacity: 0.72;
}
</style>

